/* Product details V3: gallery, variants and Ajax ATC. Other theme sections are untouched. */
(() => {
  'use strict';
  const ROOT = '.pdp-v3-wrapper';
  const route = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents, root) => {
    const currency = (root && root.dataset.currency) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents) / 100); }
    catch (_) { return '$' + (Number(cents) / 100).toFixed(2); }
  };
  function openCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.show === 'function') drawer.show();
      else drawer.setAttribute('open', '');
    } else {
      const icon = document.querySelector('a[href="/cart"],a[href="' + route() + 'cart"]');
      if (icon) icon.click(); else window.location.href = route() + 'cart';
    }
  }
  function initGallery(root) {
    const gallery = root.querySelector('.gallery-container');
    if (!gallery || gallery.dataset.galleryReady) return;
    const sliderEl = gallery.querySelector('.main-swiper');
    if (!sliderEl) return;
    gallery.dataset.galleryReady = 'true';
    const thumbs = [...gallery.querySelectorAll('.thumb-item')];
    const dots = [...gallery.querySelectorAll('.pdp-v3d-mobile-dot')];
    const slides = [...gallery.querySelectorAll('.swiper-slide.media-wrapper')];
    const initialSlide = Math.max(0, Math.min(Number(gallery.dataset.initialIndex) || 0, slides.length - 1));
    function onSlide(index, scroll) {
      const counter = gallery.querySelector('[data-pdp-gallery-current]');
      if (counter) counter.textContent = String(index + 1);
      thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.setAttribute('aria-pressed', String(i === index)); });
      dots.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.setAttribute('aria-pressed', String(i === index)); });
      if (scroll && thumbs[index]) thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i !== index) video.pause();
        else if (root.dataset.videoAutoplay === 'true' && video.muted) { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
      });
    }
    const mainSwiper = new Swiper(sliderEl, {
      loop: false, speed: 350, spaceBetween: 0, initialSlide, grabCursor: true,
      navigation: { nextEl: gallery.querySelector('.main-nav-btn.next'), prevEl: gallery.querySelector('.main-nav-btn.prev') },
      on: { slideChange() { onSlide(this.activeIndex, true); } }
    });
    gallery.pdpMainSwiper = mainSwiper;
    window.pdpMainSwiper = mainSwiper; // Retained for existing bundle swatch syncing.
    onSlide(mainSwiper.activeIndex, false);
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => mainSwiper.slideTo(i)));
    dots.forEach((dot, i) => dot.addEventListener('click', () => mainSwiper.slideTo(i)));
    const lightbox = document.getElementById('GalleryLightbox');
    let lightboxSwiper = null;
    if (lightbox) {
      document.body.appendChild(lightbox);
      const lightboxSliderEl = lightbox.querySelector('.lightbox-swiper');
      if (lightboxSliderEl) lightboxSwiper = new Swiper(lightboxSliderEl, {
        loop: false, speed: 350, spaceBetween: 18,
        navigation: { nextEl: lightbox.querySelector('.lightbox-nav-btn.next'), prevEl: lightbox.querySelector('.lightbox-nav-btn.prev') }
      });
      const closeLightbox = () => {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
        lightbox.querySelectorAll('video').forEach(v => v.pause());
        lightbox.querySelectorAll('iframe').forEach(f => { try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (_) {} });
      };
      const openLightbox = (index) => {
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        if (lightboxSwiper) { lightboxSwiper.update(); lightboxSwiper.slideTo(index, 0); }
      };
      slides.forEach((slide, i) => slide.addEventListener('click', e => {
        if (root.dataset.zoomEnabled !== 'true' || e.target.closest('.interactive-media,button,a,iframe,model-viewer')) return;
        openLightbox(i);
      }));
      const zoom = gallery.querySelector('.zoom-indicator-btn');
      if (zoom) zoom.addEventListener('click', e => { e.preventDefault(); openLightbox(mainSwiper.activeIndex); });
      const closeBtn = lightbox.querySelector('.lightbox-close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && lightbox.classList.contains('is-active')) closeLightbox(); });
    }
    gallery.querySelectorAll('.video-container').forEach(container => {
      const v = container.querySelector('video');
      const btn = container.querySelector('.btn-pause-play');
      if (!v || !btn) return;
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { const p = v.play(); if (p && p.catch) p.catch(() => {}); btn.textContent = 'Pause'; }
        else { v.pause(); btn.textContent = 'Play'; }
      });
    });
  }
  function initMediaExplorer(root) {
    const explorer = document.getElementById('V2MediaExplorer');
    if (!explorer || explorer.dataset.explorerReady) return;
    explorer.dataset.explorerReady = 'true';
    document.body.appendChild(explorer);
    const closeBtn = explorer.querySelector('.v2-exp-close');
    const panes = [...explorer.querySelectorAll('.exp-pane')];
    const swiperInstances = {};
    panes.forEach(pane => {
      const el = pane.querySelector('.exp-main-swiper');
      if (!el) return;
      const id = pane.id.replace('exp-pane-', '');
      const thumbs = [...pane.querySelectorAll('.exp-thumb-item')];
      swiperInstances[id] = new Swiper(el, {
        loop: false, speed: 350, spaceBetween: 20,
        on: { slideChange() {
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === this.activeIndex));
          if (thumbs[this.activeIndex]) thumbs[this.activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          pane.querySelectorAll('video').forEach(v => v.pause());
          const video = this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video');
          if (video && video.muted) { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
        } }
      });
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => swiperInstances[id].slideTo(index)));
    });
    function switchTab(id) {
      panes.forEach(pane => {
        const active = pane.id === 'exp-pane-' + id;
        pane.classList.toggle('is-active', active);
        if (active && swiperInstances[id]) swiperInstances[id].update();
        if (!active) pane.querySelectorAll('video').forEach(v => v.pause());
      });
      explorer.querySelectorAll('.exp-tab-btn').forEach(b => b.classList.toggle('is-active', b.dataset.expLink === id));
    }
    function closeExplorer() {
      explorer.classList.remove('is-active');
      document.body.style.overflow = '';
      explorer.querySelectorAll('video').forEach(v => v.pause());
    }
    root.querySelectorAll('[data-exp-target]').forEach(b => b.addEventListener('click', e => {
      e.preventDefault(); switchTab(b.dataset.expTarget);
      explorer.classList.add('is-active'); document.body.style.overflow = 'hidden';
    }));
    explorer.querySelectorAll('[data-exp-link]').forEach(b => b.addEventListener('click', () => switchTab(b.dataset.expLink)));
    if (closeBtn) closeBtn.addEventListener('click', closeExplorer);
    explorer.addEventListener('click', e => { if (e.target === explorer) closeExplorer(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && explorer.classList.contains('is-active')) closeExplorer(); });
  }
  function getSelectedVariantId(button) {
    const root = button.closest(ROOT);
    if (root && root.classList.contains('is-design-v3') && root.querySelector('.pdp-v3d-options')) return root.dataset.v3SelectedId || null;
    const picker = root && root.querySelector('variant-selector');
    if (picker && picker.currentVariant && picker.currentVariant.id) return String(picker.currentVariant.id);
    const input = root && root.querySelector('variant-selector .js-master-variant-input,variant-picker input[name="id"],form[action*="/cart/add"] input[name="id"],.js-master-variant-input');
    return (input && input.value) || button.dataset.productId;
  }
  function initBuy(root) {
    root.querySelectorAll('.custom-ajax-atc').forEach(button => {
      if (button.dataset.atcReady) return;
      button.dataset.atcReady = 'true';
      button.addEventListener('click', async e => {
        e.preventDefault();
        if (button.disabled) return;
        const id = getSelectedVariantId(button);
        const quantityInput = root.querySelector('.pdp-v3-quantity');
        const quantity = Math.max(1, Math.floor(Number(quantityInput && quantityInput.value) || 1));
        root.querySelectorAll('[data-pdp-v3-form-quantity]').forEach(el => { el.value = String(quantity); });
        if (!id) { alert('Please select an available option.'); return; }
        const normal = button.querySelector('.atc-text');
        const loading = button.querySelector('.atc-loading');
        button.disabled = true;
        if (normal) normal.hidden = true;
        if (loading) loading.hidden = false;
        try {
          const response = await fetch(route() + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }] })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');
          openCart();
        } catch (error) { console.error('Product add-to-cart:', error); alert(error.message || 'Failed to add item. Please try again.'); }
        finally {
          button.disabled = button.dataset.variantAvailable === 'false';
          if (normal) normal.hidden = false;
          if (loading) loading.hidden = true;
        }
      });
    });
  }
  function initLegacyBlocks(root) {
    if (root.dataset.legacyReady) return;
    root.dataset.legacyReady = 'true';
    root.addEventListener('click', async e => {
      const stepper = e.target.closest('.pdp-v3-quantity-step');
      if (stepper && root.contains(stepper)) {
        const q = stepper.parentElement.querySelector('.pdp-v3-quantity');
        if (q) { q.value = Math.max(1, (Math.floor(Number(q.value) || 1) + Number(stepper.dataset.step))); root.querySelectorAll('.pdp-v3-payment-quantity').forEach(el => { el.value = q.value; }); }
        return;
      }
      const code = e.target.closest('.pdp-v3-copy-code');
      if (code && root.contains(code)) {
        try {
          await navigator.clipboard.writeText(code.dataset.code || '');
          const label = code.innerHTML; code.textContent = 'Copied!';
          setTimeout(() => { code.innerHTML = label; }, 1400);
        } catch (_) { window.prompt('Copy discount code:', code.dataset.code || ''); }
        return;
      }
      const add = e.target.closest('.pdp-v3-addon-add');
      if (!add || !root.contains(add) || add.disabled) return;
      const item = add.closest('.pdp-v3-addon-item');
      const variant = item && item.querySelector('.pdp-v3-addon-variant');
      const id = variant && variant.value;
      if (!id) return;
      const label = add.textContent;
      add.disabled = true; add.textContent = 'ADDING...';
      try {
        const res = await fetch(route() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add accessory');
        openCart();
      } catch (error) { alert(error.message || 'Failed to add accessory'); }
      finally { add.disabled = false; add.textContent = label; }
    });
    root.addEventListener('change', e => {
      const el = e.target;
      if (el.matches && el.matches('.pdp-v3-quantity')) {
        const n = Math.max(1, Math.floor(Number(el.value) || 1));
        el.value = n;
        root.querySelectorAll('.pdp-v3-payment-quantity').forEach(hidden => { hidden.value = String(n); });
      }
      if (el.matches && el.matches('.pdp-v3-addon-variant')) {
        const opt = el.options && el.options[el.selectedIndex];
        const price = el.closest('.pdp-v3-addon-item').querySelector('.pdp-v3-addon-price');
        if (opt && price && opt.dataset.price) price.textContent = money(opt.dataset.price, root);
      }
    });
  }

  // Smooth, interruptible accordion: works with native details keyboard semantics.
  // JS only intercepts activation, so native details still works as fallback.
  function initDesignAccordion(root) {
    root.querySelectorAll('.pdp-v3d-details details').forEach(details => {
      if (details.dataset.v3AccordionReady) return;
      const summary = details.querySelector('summary');
      const body = details.querySelector('.pdp-v3d-details-body');
      if (!summary || !body) return;
      details.dataset.v3AccordionReady = 'true';
      let animation = null;
      let wantedOpen = details.open;
      const reset = () => { details.style.height = ''; details.style.overflow = ''; details.classList.remove('is-closing'); };
      function setOpen(open) {
        open = Boolean(open);
        if (wantedOpen === open && !animation && details.open === open) return;
        wantedOpen = open;
        const start = details.getBoundingClientRect().height;
        if (animation) { animation.cancel(); animation = null; }
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion || typeof details.animate !== 'function') { details.open = open; reset(); return; }
        if (open) details.open = true;
        details.classList.toggle('is-closing', !open);
        const end = summary.getBoundingClientRect().height + (open ? body.getBoundingClientRect().height : 0);
        details.style.height = start + 'px';
        details.style.overflow = 'hidden';
        const current = details.animate([{ height: start + 'px' }, { height: end + 'px' }], {
          duration: 340, easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        });
        animation = current;
        current.onfinish = () => {
          if (animation !== current) return;
          details.open = open;
          animation = null;
          reset();
        };
        current.oncancel = () => { if (animation === current) animation = null; };
      }
      // Used by the CHECK FIT & INSTALLATION anchor as well as the summary.
      details.pdpV3SetOpen = setOpen;
      summary.addEventListener('click', e => { e.preventDefault(); setOpen(!wantedOpen); });
    });
  }

  // All new design interactions are scoped to the V3 section. Legacy features remain untouched.
  // Klaviyo's automatic placement can mistake the cart-drawer checkout form for a PDP purchase form.
  // The anchor and a real product form give it a product-specific target; relocation is a scoped fallback.
  function initKlaviyoPlacement(root) {
    const slot = root.querySelector('[data-pdp-v3-bis-slot]');
    if (!slot || slot.dataset.bisReady) return;
    slot.dataset.bisReady = 'true';
    const trigger = slot.querySelector('.klaviyo-bis-trigger');
    if (trigger) trigger.addEventListener('click', e => e.preventDefault());
    const sync = () => {
      if (!document.contains(root)) return;
      const misplaced = document.querySelectorAll('cart-drawer form.buy-buttons[action="/cart"] #klaviyo-bis-button-container, form.buy-buttons--compact[action="/cart"] #klaviyo-bis-button-container, .pdp-v3-wrapper .pdp-v3d-product-form #klaviyo-bis-button-container');
      misplaced.forEach(el => { if (!slot.contains(el)) slot.appendChild(el); });
      const primary = root.querySelector('.pdp-v3d-actions .custom-ajax-atc');
      const soldOut = Boolean(primary && primary.dataset.variantAvailable === 'false' && root.dataset.v3SelectedId);
      slot.hidden = !soldOut;
      if (trigger) trigger.hidden = !soldOut || Boolean(slot.querySelector('#klaviyo-bis-button-container'));
    };
    root.pdpV3SyncKlaviyo = sync;
    sync();
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(() => {
        if (!document.contains(root)) { observer.disconnect(); return; }
        sync();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  function initStickyCart(root) {
    const sticky = root.querySelector('[data-pdp-v3-sticky]');
    if (!sticky || sticky.dataset.stickyReady) return;
    const primary = root.querySelector('.pdp-v3d-actions .custom-ajax-atc, .info-block-buy .custom-ajax-atc');
    if (!primary) return;
    const stickyButton = sticky.querySelector('.pdp-v3-sticky-add');
    const stickyPrice = sticky.querySelector('[data-pdp-v3-sticky-price]');
    let scrolledPast = false;
    sticky.dataset.stickyReady = 'true';
    const sync = () => {
      const available = primary.dataset.variantAvailable !== 'false' && !primary.disabled;
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      sticky.hidden = !scrolledPast;
      const price = root.querySelector('.pdp-v3d-live-price,.price-current');
      if (price && stickyPrice) stickyPrice.textContent = price.textContent;
    };
    stickyButton.addEventListener('click', () => { if (!stickyButton.disabled) primary.click(); });
    root.pdpV3UpdateSticky = sync;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sync();
      });
      observer.observe(primary);
    } else {
      const onScroll = () => { scrolledPast = primary.getBoundingClientRect().bottom < 0; sync(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    sync();
  }

  function initDesignBlocks(root) {
    if (!root.classList.contains('is-design-v3') || root.dataset.designReady) return;
    root.dataset.designReady = 'true';
    initDesignAccordion(root);
    const json = root.querySelector('.pdp-v3-variants-json');
    let variants = [];
    try { variants = json ? JSON.parse(json.textContent || '[]') : []; }
    catch (err) { console.warn('V3 design: invalid variants JSON', err); }
    const optionPicker = root.querySelector('.pdp-v3d-options');
    const fields = optionPicker ? [...optionPicker.querySelectorAll('fieldset[data-option-index]')] : [];
    const initiallySelected = root.dataset.v3SelectedId;
    const getChosenOptions = () => fields.map(f => {
      const selected = f.querySelector('input.pdp-v3d-option-radio:checked');
      return selected ? selected.value : null;
    });
    function syncPicker(variant) {
      const picker = root.querySelector('variant-selector');
      if (!picker || !variant) return;
      let changedInput = null;
      [...picker.querySelectorAll('fieldset')].forEach((field, index) => {
        const choice = [...field.querySelectorAll('input[type="radio"]')].find(el => el.value === variant.options[index]);
        if (choice && !choice.checked) { choice.checked = true; changedInput = choice; }
      });
      if (changedInput) changedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function applyVariant(variant, syncOld = false) {
      root.dataset.v3SelectedId = variant ? String(variant.id) : '';
      if (variant) {
        fields.forEach(field => {
          // Shopify option indexes are positional; data-option-index avoids relying on DOM order.
          const fieldIndex = Number(field.dataset.optionIndex);
          const exact = [...field.querySelectorAll('input.pdp-v3d-option-radio')].find(el => el.value === String(variant.options[fieldIndex]));
          if (exact) exact.checked = true;
          const caption = field.querySelector('[data-v3d-selected-value]');
          if (caption && exact) caption.textContent = exact.value;
        });
      } else {
        fields.forEach(field => {
          const caption = field.querySelector('[data-v3d-selected-value]');
          const input = field.querySelector('input.pdp-v3d-option-radio:checked');
          if (caption && input) caption.textContent = input.value;
        });
      }
      const status = root.querySelector('.pdp-v3d-status');
      if (status) {
        const priceEl = status.querySelector('.pdp-v3d-live-price');
        const availabilityEl = status.querySelector('.pdp-v3d-live-availability');
        if (priceEl && status.dataset.priceMode !== 'reference') priceEl.textContent = variant ? money(variant.price, root) : 'Unavailable';
        if (availabilityEl && status.dataset.availabilityMode !== 'reference') {
          availabilityEl.textContent = !variant ? 'Unavailable' : variant.available ? (status.dataset.availableText || 'In stock') : (status.dataset.unavailableText || 'Sold out');
        }
      }
      root.querySelectorAll('[data-v3d-sku]').forEach(el => { if (variant) el.textContent = variant.sku || root.dataset.productHandle || 'Product'; });
      const btn = root.querySelector('.pdp-v3d-actions .custom-ajax-atc');
      if (btn) {
        const available = Boolean(variant && variant.available);
        btn.dataset.variantAvailable = String(available);
        btn.dataset.productId = variant ? String(variant.id) : '';
        btn.disabled = !available;
        const text = btn.querySelector('.atc-text');
        if (text) text.textContent = !variant ? 'UNAVAILABLE' : available ? (btn.dataset.customLabel || 'ADD TO CART') : 'SOLD OUT';
      }
      root.querySelectorAll('.pdp-v3-payment-variant-id').forEach(el => {
        if (variant && el.value !== String(variant.id)) { el.value = String(variant.id); if (el.closest('.pdp-v3d-product-form')) el.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (root.pdpV3SyncKlaviyo) root.pdpV3SyncKlaviyo();
      if (root.pdpV3UpdateSticky) root.pdpV3UpdateSticky();
      if (syncOld && variant) syncPicker(variant);
      if (variant && variant.id) {
        const gallery = root.querySelector('.gallery-container');
        const swiper = gallery && gallery.pdpMainSwiper || window.pdpMainSwiper;
        if (gallery && swiper) {
          let slide = null;
          if (variant.featured_media && variant.featured_media.id) slide = gallery.querySelector('.media-wrapper[data-media-id="' + variant.featured_media.id + '"]');
          if (!slide && variant.featured_image && variant.featured_image.id) slide = gallery.querySelector('.media-wrapper[data-media-id="' + variant.featured_image.id + '"]');
          if (!slide && variant.featured_image && variant.featured_image.src) {
            const basename = src => {
              try { return new URL(src, location.href).pathname.split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/,'').toLowerCase(); }
              catch (_) { return String(src).split('?')[0].split('/').pop().toLowerCase(); }
            };
            const wanted = basename(variant.featured_image.src);
            slide = [...gallery.querySelectorAll('.media-wrapper')].find(el => basename(el.dataset.mediaSrc || '') === wanted);
          }
          if (slide) swiper.slideTo(Number(slide.dataset.index) || 0);
        }
      }
    }
    if (fields.length) {
      optionPicker.addEventListener('change', e => {
        if (!e.target.matches('input.pdp-v3d-option-radio')) return;
        const opts = getChosenOptions();
        const variant = variants.find(v => v.options && v.options.every((value, index) => value === opts[index]));
        applyVariant(variant || null, true);
        if (variant) {
          try { const u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.href); } catch (_) {}
        }
      });
    }
    const selected = variants.find(v => String(v.id) === String(initiallySelected)) || variants[0];
    if (selected) applyVariant(selected);
    // Existing and new variant selectors coexist; both remain in the normal block order.
    const legacy = root.querySelector('variant-selector');
    if (legacy) legacy.addEventListener('change', () => {
      Promise.resolve().then(() => { if (legacy.currentVariant) applyVariant(legacy.currentVariant, false); });
    });
    // Native share sheet on phones; copy direct product URL on desktop.
    root.querySelectorAll('[data-v3d-share]').forEach(button => {
      button.addEventListener('click', async () => {
        const feedback = button.parentElement.querySelector('.pdp-v3d-share-feedback');
        const url = location.href;
        try {
          if (navigator.share) await navigator.share({ title: document.title, url });
          else if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            if (feedback) feedback.textContent = 'Link copied';
          } else window.prompt('Copy product URL:', url);
        } catch (err) {
          if (err && err.name === 'AbortError') return;
          window.prompt('Copy product URL:', url);
        }
      });
    });
    root.querySelectorAll('.pdp-v3d-secondary[href^="#"]').forEach(link => {
      link.addEventListener('click', e => {
        const id = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (target && root.contains(target)) {
          e.preventDefault();
          const details = target.querySelector('details');
          if (details) {
            if (typeof details.pdpV3SetOpen === 'function') details.pdpV3SetOpen(true);
            else details.open = true;
          }
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(root => {
      initBuy(root);
      initLegacyBlocks(root);
      initKlaviyoPlacement(root);
      initDesignBlocks(root);
      initStickyCart(root);
      if (typeof window.Swiper === 'function') { initGallery(root); initMediaExplorer(root); }
      else if (!root.dataset.waitingForSwiper) {
        root.dataset.waitingForSwiper = 'true';
        let tries = 0;
        const timer = setInterval(() => {
          if (typeof window.Swiper === 'function') { clearInterval(timer); initGallery(root); initMediaExplorer(root); }
          else if (++tries >= 80 || !document.contains(root)) clearInterval(timer);
        }, 100);
      }
    });
  }

  function initAddons(){
    if (typeof jQuery !== 'undefined') {
      jQuery(function($) {
        
        // Bundles Swatches Selection
        $(document).on('click', '.pdp-v3-wrapper .bundle-swatch-btn', function() {
          var $btn = $(this);
          var $itemContainer = $btn.closest('.product_info_bundles_item');
          var $swatchWrapper = $btn.closest('.bundle-swatch-wrapper');
          
          $swatchWrapper.find('.bundle-swatch-btn').removeClass('is-active');
          $btn.addClass('is-active');
          
          var variantTitle = $btn.data('variant-title');
          $swatchWrapper.find('.bundle-swatch-value').text(variantTitle);
          $itemContainer.find('.product_info_bundles_item_price').text($btn.data('variant-price'));
          $itemContainer.removeClass('product_info_bundles_item_act');
  
          var newImageSrc = $btn.data('variant-image');
          if (newImageSrc) {
            var $imageEl = $itemContainer.find('.product_info_bundles_item_images img');
            $imageEl.css('opacity', '0.5'); 
            setTimeout(function() {
              $imageEl.attr('src', newImageSrc);
              $imageEl.css('opacity', '1');
            }, 100); 
          }

          // 🎯 新增：读取后台设置开关，联动主画廊同步切换
          var isSyncEnabled = $itemContainer.closest('.product_info_bundles_op_b2').data('gallery-sync');
          
          if ((isSyncEnabled === true || isSyncEnabled === 'true') && variantTitle) {
            var searchStr = variantTitle.toLowerCase().replace(/\s+/g, '_'); 
            var fallbackStr = variantTitle.toLowerCase().replace(/\s+/g, '-'); 
            
            // 如果存在新版全局画廊
            if (window.pdpMainSwiper) {
              var $gallerySlides = $('.main-swiper .swiper-slide');
              var matchedIndex = -1;
              $gallerySlides.each(function() {
                var src = $(this).attr('data-media-src') || "";
                if (src.includes(searchStr) || src.includes(fallbackStr)) {
                  matchedIndex = $(this).data('index');
                  return false;
                }
              });
              if (matchedIndex !== -1) {
                window.pdpMainSwiper.slideTo(matchedIndex);
              }
            } 
            // 否则尝试适配旧版原声画廊
            else {
              var $nativeThumbnails = $('.product-gallery__thumbnail');
              if ($nativeThumbnails.length > 0) {
                $nativeThumbnails.each(function() {
                  var src = $(this).attr('data-media-src') || "";
                  if (src.includes(searchStr) || src.includes(fallbackStr)) {
                    $(this).click(); 
                    return false;
                  }
                });
              }
            }
          }
        });
  
        // Bundles ATC Click
        $(document).on('click', '.pdp-v3-wrapper .product_info_bundles_item_add2', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var $currentParent = $btn.closest('.product_info_bundles_item');
          var $activeSwatch = $currentParent.find('.bundle-swatch-btn.is-active');
          var targetVariantId = $activeSwatch.length > 0 ? String($activeSwatch.data('variant-id')) : String($btn.attr("data-default-id"));
          
          $btn.css('pointer-events', 'none');
          
          if ($currentParent.hasClass("product_info_bundles_item_act")) {
            $.ajax({
              type: 'GET', url: window.Shopify.routes.root + 'cart.js', dataType: 'json',
              success: function(cart) {
                var currentItem = cart.items.find(item => String(item.variant_id) === targetVariantId || String(item.id) === targetVariantId);
                var newQty = currentItem && currentItem.quantity > 0 ? currentItem.quantity - 1 : 0;
                $.ajax({
                  type: 'POST', url: window.Shopify.routes.root + 'cart/change.js',
                  data: JSON.stringify({ id: targetVariantId, quantity: newQty }),
                  dataType: 'json', contentType: 'application/json',
                  success: function() {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                      else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                      else { cartDrawer.setAttribute('open', ''); }
                    }
                    $currentParent.removeClass("product_info_bundles_item_act");
                    $btn.css('pointer-events', 'auto');
                  },
                  error: function() { $btn.css('pointer-events', 'auto'); }
                });
              },
              error: function() { $btn.css('pointer-events', 'auto'); }
            });
          } else {
            $.ajax({
              type: 'POST', url: window.Shopify.routes.root + 'cart/add.js',
              data: JSON.stringify({ 'items': [{ 'id': targetVariantId, 'quantity': 1 }] }),
              dataType: 'json', contentType: 'application/json',
              success: function() {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                  else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                  else { cartDrawer.setAttribute('open', ''); }
                } else {
                  const cartIcon = document.querySelector('a[href="/cart"], a[href="' + window.Shopify.routes.root + 'cart"]');
                  if (cartIcon) { cartIcon.click(); } else { window.location.href = window.Shopify.routes.root + 'cart'; }
                }
                $currentParent.addClass("product_info_bundles_item_act");
                $btn.css('pointer-events', 'auto');
              },
              error: function(err) {
                alert('Failed to add item to cart.');
                $btn.css('pointer-events', 'auto');
              }
            });
          }
        });
  
        // Extend Protection ATC Click
        $(document).on('click', '.pdp-v3-wrapper .extend-protection-add-btn', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var blockId = $btn.data('block-id');
          var id = $('input[name="warranty_variant_' + blockId + '"]:checked').val();
          
          if (!id) return;
          $btn.css('pointer-events', 'none');
          var originalText = $btn.find('.ep-btn-text').text();
          $btn.find('.ep-btn-text').text('Adding...');
    
          // 同样优化：延保也优先找 variant-picker 获取商品真实选中的 SKU
          var currentSku = String($btn.data('fallback-sku'));
          var officialSkuElement = document.querySelector('variant-sku');
          if (officialSkuElement && officialSkuElement.textContent.trim() !== '') {
            currentSku = officialSkuElement.textContent.replace('SKU:', '').trim();
          } else {
             var $skuElement = $('.pdp-v3-wrapper variant-sku'); 
             if ($skuElement.length && $skuElement.text().trim() !== '') {
                currentSku = $skuElement.text().replace('SKU:', '').trim();
             }
          }
    
          $.ajax({
            type: 'POST', url: window.Shopify.routes.root + 'cart/add.js',
            data: JSON.stringify({
              'items': [{ 'id': id, 'quantity': 1, 'properties': { 'Main_Product_SKU': currentSku } }]
            }),
            dataType: 'json', contentType: 'application/json',
            success: function() {
              $btn.find('.ep-btn-text').text('Added!');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
              }
              setTimeout(function() {
                $btn.find('.ep-btn-text').text(originalText);
                $btn.css('pointer-events', 'auto');
              }, 2000);
            },
            error: function(err) {
              alert('Failed to add item to cart.');
              $btn.find('.ep-btn-text').text(originalText);
              $btn.css('pointer-events', 'auto');
            }
          });
        });
  
      });
    }
  }
  class CustomVariantSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.variantReady) return;
      this.dataset.variantReady = 'true';
      const jsonEl = this.querySelector('.variant-json');
      try { this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : []; }
      catch (error) { console.warn('Invalid product variant data', error); this.variantData = []; }
      this.masterInput = this.querySelector('.js-master-variant-input') || (this.closest(ROOT) && this.closest(ROOT).querySelector('.js-master-variant-input'));
      this.addEventListener('change', e => this.onVariantChange(e));
      // Respect the actual selected variant on first render and on variant-linked URLs.
      this.onVariantChange(null, true);
    }
    onVariantChange(event, initial = false) {
      if (event && !event.target.closest('fieldset')) return;
      const fields = [...this.querySelectorAll('fieldset')];
      const options = fields.map(field => {
        const checked = field.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
      if (!fields.length || options.some(o => o === null)) return;
      if (event && event.target.closest('fieldset')) {
        const display = event.target.closest('fieldset').querySelector('.js-selected-value');
        if (display) display.textContent = event.target.value;
      }
      const variant = (this.variantData || []).find(v => v.options && v.options.every((option, index) => option === options[index]));
      const root = this.closest(ROOT);
      if (!root) return;
      const btn = root.querySelector('.pdp-v3d-actions .custom-ajax-atc, .info-block-buy .custom-ajax-atc');
      if (!variant) {
        this.currentVariant = null;
        root.dataset.v3SelectedId = '';
        if (btn) { btn.disabled = true; btn.dataset.variantAvailable = 'false'; const t = btn.querySelector('.atc-text'); if (t) t.textContent = 'UNAVAILABLE'; }
        if (root.pdpV3SyncKlaviyo) root.pdpV3SyncKlaviyo();
        if (root.pdpV3UpdateSticky) root.pdpV3UpdateSticky();
        return;
      }
      this.currentVariant = variant;
      root.dataset.v3SelectedId = String(variant.id);
      root.querySelectorAll('.pdp-v3-payment-variant-id').forEach(el => { el.value = String(variant.id); el.dispatchEvent(new Event('change', { bubbles: true })); });
      if (root.pdpV3SyncKlaviyo) root.pdpV3SyncKlaviyo();
      if (root.pdpV3UpdateSticky) root.pdpV3UpdateSticky();
      if (this.masterInput) { this.masterInput.value = String(variant.id); this.masterInput.dispatchEvent(new Event('input', { bubbles: true })); }
      if (!initial) {
        try { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString()); } catch (_) {}
      }
      const current = root.querySelector('.price-current');
      const compare = root.querySelector('.price-compare');
      const save = root.querySelector('.price-save-badge');
      if (current) current.textContent = money(variant.price, root);
      const hasSave = Number(variant.compare_at_price) > Number(variant.price);
      if (compare) { compare.hidden = !hasSave; if (hasSave) compare.textContent = money(variant.compare_at_price, root); }
      if (save) { save.hidden = !hasSave; if (hasSave) save.textContent = 'Save ' + money(variant.compare_at_price - variant.price, root); }
      if (btn) {
        btn.dataset.productId = String(variant.id);
        btn.dataset.variantAvailable = String(Boolean(variant.available));
        btn.disabled = !variant.available;
        const text = btn.querySelector('.atc-text');
        if (text) text.textContent = !variant.available ? 'SOLD OUT' : btn.dataset.dynamicLabel === 'true' ? 'GET ' + (variant.sku || 'PRODUCT') : (btn.dataset.customLabel || 'ADD TO CART');
      }
      if (root.pdpV3SyncKlaviyo) root.pdpV3SyncKlaviyo();
      if (root.pdpV3UpdateSticky) root.pdpV3UpdateSticky();
      const gallery = root.querySelector('.gallery-container');
      const slider = window.pdpMainSwiper;
      if (!gallery || !slider) return;
      let matchedSlide = null;
      if (variant.featured_media && variant.featured_media.id) matchedSlide = gallery.querySelector('.media-wrapper[data-media-id="' + variant.featured_media.id + '"]');
      const image = variant.featured_image;
      if (!matchedSlide && image && image.src) {
        const path = src => {
          try { return decodeURIComponent(new URL(src, window.location.origin).pathname).toLowerCase().replace(/_\d+x\d*(?=\.[a-z]+$)/, ''); }
          catch (_) { return src.split('?')[0].toLowerCase(); }
        };
        const expected = path(image.src);
        matchedSlide = [...gallery.querySelectorAll('.media-wrapper')].find(el => path(el.dataset.mediaSrc || '') === expected);
      }
      if (matchedSlide) slider.slideTo(Number(matchedSlide.dataset.index) || 0);
    }
  }
  if (window.customElements && !customElements.get('variant-selector')) customElements.define('variant-selector', CustomVariantSelector);
  function ready() { initAll(); initAddons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', () => initAll());
})();
